import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AccountsMenu from "./AccountsMenu";
import { NavLink, Link } from "react-router-dom";
import YearsDropDown from "../Shared/YearsDropDown";
import Pagination from "../General/Pagination";
import moment from "moment";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { calculateColumnTotal } from "../General/Utility";

function IncomeExpenditure(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [DefaultFYear, setDefaultFYear] = useState(
    localStorage.getItem("DefaultFYear")
  );
  const [listOfLedger, setLedger] = useState([]);

  const [AccountLevel, setAccountLevel] = useState("0");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [LedgerIncome, setLedgerIncome] = useState([]);
  const [LedgerExpenses, setLedgerExpenses] = useState([]);

  const [Account_Code, setAccount_Code] = useState("");
  const [Account_Description, setAccount_Description] = useState("");
  const [zeroAccounts, setZeroAccounts] = useState(true);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [IncomeTotal, setIncomeTotal] = useState(0);
  const [ExpanditureTotal, setExpanditureTotal] = useState(0);

  useEffect(() => {
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      PageNo: pageNo,
      PageSize: 1000,
      FYear: DefaultFYear,
      StartDate: StartDate,
      EndDate: EndDate,
      AccountLevel: AccountLevel,
      ShowZeroAccounts: zeroAccounts,
    };

    console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "Accounts/GetIncomeExpenditure",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        console.log(response.data);
        if (response.data.status_code != 0) {
          setLedgerIncome(response.data.IncomeAccounts);
          setLedgerExpenses(response.data.ExpenditureAccounts);
          setIncomeTotal(response.data.IncomeTotal);
          setExpanditureTotal(response.data.ExpanditureTotal);
        } else {
          setLedgerIncome(null);
          setLedgerExpenses(null);
        }

        setLoading(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [
    pageNo,
    pageSize,
    DefaultFYear,
    AccountLevel,
    StartDate,
    EndDate,
    zeroAccounts,
    Account_Code,
    Account_Description,
  ]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedgerIncome = () => {
    if (LedgerIncome != null && LedgerIncome.length > 0) {
      let count = 1;
      return LedgerIncome.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Account_Code}</td>
            <td>{item.Account_Description}</td>
            <td>{item.Amount}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="4">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const renderLedgerExpenditure = () => {
    if (LedgerExpenses != null && LedgerExpenses.length > 0) {
      let count = 1;
      return LedgerExpenses.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Account_Code}</td>
            <td>{item.Account_Description}</td>
            <td>{item.Amount}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="4">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <AccountsMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">
                        Accounts
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Income and Expenditure Statement
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Income and Expenditure</div>
              </div>
              <div className="col-md-6"></div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center gy-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label >Select Level:</label>
                      <select
                        className="form-select"
                        onChange={(e) => setAccountLevel(e.target.value)}
                      >
                        <option selected value="0">
                          Select Level
                        </option>
                        <option selected value="1">
                          1st Level
                        </option>
                        <option selected value="2">
                          2st Level
                        </option>
                        <option selected value="3">
                          3st Level
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label >Start Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                        max={moment().format(config.date_format_input)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label >End Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => setEndDate(e.target.value)}
                        required
                        max={moment().format(config.date_format_input)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <div className="form-check mt-md-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={zeroAccounts}
                          onChange={(e) => setZeroAccounts(e.target.checked)}
                          id="flexCheckDefault"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Show Zero Accounts:
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card mt-4">
                  <div className="card-body responsive-table">
                    <table className="table table-theme table-hover">
                      <tbody>
                        <tr>
                          <th colSpan={3}>Income</th>
                        </tr>
                        <tr>
                          <th>Account Code</th>
                          <th>Account Name</th>
                          <th>Amount</th>
                        </tr>

                        {loading ? (
                          <tr>
                            <td className="text-center" colSpan="4">
                              <Spinner
                                animation="border"
                                role="status"
                              ></Spinner>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {renderLedgerIncome()}
                           <tr >
                            <th className="text-end" colSpan={2}>
                              Total Amount:
                            </th>
                            <th className="">
                              {/* {calculateColumnTotal(
                                listOfLedger,
                                "Amount"
                              )} */}
                            {IncomeTotal}

                            </th>
                            </tr> 
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card mt-4">
                  <div className="card-body responsive-table">
                    <table className="table table-theme table-hover">
                      <tbody>
                        <tr>
                          <th colSpan={3}>Expenditure</th>
                        </tr>
                        <tr>
                          <th>Account Code</th>
                          <th>Account Name</th>
                          <th>Amount</th>
                        </tr>
                        {loading ? (
                          <tr>
                            <td className="text-center" colSpan="4">
                              <Spinner
                                animation="border"
                                role="status"
                              ></Spinner>
                            </td>
                          </tr>
                        ) : (
                          <>
                          {renderLedgerExpenditure()}
                          <tr >
                            <th className="text-end" colSpan={2}>
                              Total Amount:
                            </th>
                            <th className="">
                              {/* {calculateColumnTotal(
                                listOfLedger,
                                "Amount"
                              )} */}

                              {ExpanditureTotal}
                            </th>
                            </tr> 
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="card mt-2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-2 offset-md-10 text-end">
                    <div className="form-group text-end">
                      <Link
                        to={`/Accounts/PrintIncomeExpenditure?StartDate=${StartDate}&EndDate=${EndDate}&Level=${AccountLevel}&zeroAccount=${zeroAccounts}`}
                        target="_blank"
                        className="w-100 button button-primary"
                      >
                        Print This List
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IncomeExpenditure;
